var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSensorWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_159877",
    "data-name": "Group 159877",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.637,
    height: 26.986,
    viewBox: "0 0 34.637 26.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147481",
    "data-name": "Rectangle 147481",
    width: 34.637,
    height: 26.986,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_159876",
    "data-name": "Group 159876",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37521",
    "data-name": "Path 37521",
    d: "M365.982,6.652a1,1,0,0,1-.712-.3,14.831,14.831,0,0,0-20.977,0,1.007,1.007,0,0,1-1.424-1.424,16.849,16.849,0,0,1,23.826,0,1.006,1.006,0,0,1-.713,1.718m-18.358,4.042a1.007,1.007,0,0,1-.712-1.719,11.132,11.132,0,0,1,15.74,0,1.006,1.006,0,1,1-1.422,1.424,9.118,9.118,0,0,0-12.893,0,1.011,1.011,0,0,1-.713.3M357.9,14.737a1,1,0,0,1-.713-.3,3.4,3.4,0,0,0-4.808,0,1.007,1.007,0,0,1-1.424-1.424,5.411,5.411,0,0,1,7.655,0,1.007,1.007,0,0,1,0,1.422.991.991,0,0,1-.712.3",
    transform: "translate(-337.463 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37522",
    "data-name": "Path 37522",
    d: "M260.227,1409.5a1.026,1.026,0,1,0,1.025,1.025,1.028,1.028,0,0,0-1.025-1.025",
    transform: "translate(-255.332 -1388.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37523",
    "data-name": "Path 37523",
    d: "M623.427,1409.5a1.026,1.026,0,1,0,1.025,1.025,1.028,1.028,0,0,0-1.025-1.025",
    transform: "translate(-613.113 -1388.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37524",
    "data-name": "Path 37524",
    d: "M988.211,1303.3a2.611,2.611,0,1,0,2.61,2.61,2.614,2.614,0,0,0-2.61-2.61",
    transform: "translate(-970.893 -1283.852)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37525",
    "data-name": "Path 37525",
    d: "M1562.227,1409.5a1.026,1.026,0,1,0,1.025,1.025,1.028,1.028,0,0,0-1.025-1.025",
    transform: "translate(-1537.904 -1388.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37526",
    "data-name": "Path 37526",
    d: "M1925.427,1409.5a1.026,1.026,0,1,0,1.025,1.025,1.028,1.028,0,0,0-1.025-1.025",
    transform: "translate(-1895.684 -1388.468)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37527",
    "data-name": "Path 37527",
    d: "M29.71,1148.1H4.927a4.927,4.927,0,0,0,0,9.854H29.71a4.927,4.927,0,0,0,0-9.854m-12.391,1.485a3.442,3.442,0,1,1-3.442,3.441,3.445,3.445,0,0,1,3.442-3.441m-7,1.585a1.857,1.857,0,1,1-1.858,1.856,1.858,1.858,0,0,1,1.858-1.856m-5.42,0a1.857,1.857,0,1,1-1.858,1.856,1.858,1.858,0,0,1,1.858-1.856m22.99,1.856a1.857,1.857,0,1,1,1.858,1.858,1.86,1.86,0,0,1-1.858-1.858m-5.418,0a1.857,1.857,0,1,1,1.858,1.858,1.86,1.86,0,0,1-1.858-1.858",
    transform: "translate(0 -1130.968)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorWhite);
export default __webpack_public_path__ + "static/media/Sensor-White.ec3e316bdde7cc07a53dab16ef6f0bd1.svg";
export { ForwardRef as ReactComponent };